import _ from 'underscore';

export const INVALID_ACCOUNT_STATUS = {
  Inactive: '32',
  Deleted: '33',
};

export const ACCOUNT_INACTIVE_REASONS = {
  Inactive: '7',
};

export function isAccountStatusValidToSwitch(account) {
  return account &&
    !_.contains(INVALID_ACCOUNT_STATUS, `${account.Status}`) &&
    !_.contains(ACCOUNT_INACTIVE_REASONS, `${account.InactiveReasons}`);
}

export function hasEditPermissions(permissions) {
  // Note: if permissions.IsEditAccountEnabled is undefined, assume the user has permission
  return !!(permissions && (permissions.IsEditAccountEnabled !== false));
}

export function hasCreatePermissions(permissions) {
  // Note: if permissions.IsCreateAccountEnabled is undefined, assume the user has permission
  return !!(permissions && (permissions.IsCreateAccountEnabled !== false));
}
